import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import { History } from '@leverege/molten-core';
export default class InactivityTimer {
  constructor() {
    this.maxInactiveTime = Config.get('InactivityTimer', 'maxInactiveTime', 1000 * 60 * 40);
    this.timer = null;
    this.timeOrigin = Date.now();
    this.lastActive = this.timeOrigin;
  }
  init() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.checkUserActivity, this.maxInactiveTime);
    this.addListeners();
  }
  checkUserActivity = () => {
    const now = Date.now();
    const timeSinceActive = now - this.lastActive;
    if (timeSinceActive > this.maxInactiveTime) {
      localStorage.setItem('lastActivePage', window.location.pathname + window.location.search);
      GlobalState.dispatch(History.push('/inactive'));
    } else {
      this.timer = setTimeout(this.checkUserActivity, this.maxInactiveTime - timeSinceActive);
    }
  };
  onMouseMove = evt => {
    this.lastActive = this.timeOrigin + evt.timeStamp;
  };
  addListeners() {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('touchmove', this.onMouseMove);
  }
}